const fdaPmaTheme = {
  dot: "bg-lime-400",
  accentText: "text-lime-200",
  subtleText: "text-lime-300",
  tabActive: "border-lime-400/40 bg-lime-500/10 text-lime-100",
  selectedRow: "border-l-2 border-lime-400 bg-lime-500/[0.08]",
  accentBadge: "border border-lime-400/30 bg-lime-500/10 text-lime-100",
  idBadge: "border border-lime-400/25 bg-lime-500/5 text-lime-100",
  detailBorder: "border-lime-400/25",
  detailGlow: "from-lime-400/25",
  checkbox:
    "border-lime-300/35 text-lime-200 hover:border-lime-200/55 hover:bg-lime-950/70 focus-visible:ring-lime-300/25",
  checkboxChecked:
    "border-lime-100/70 from-lime-300 to-emerald-400 shadow-[0_0_0_1px_rgba(217,249,157,0.16),0_10px_22px_rgba(132,204,22,0.24)]",
};

export default fdaPmaTheme;
